import $ from 'jquery';
import Audio from '@/lib/audio.js';
import Cards from '@/lib/cards.js';
import isMobile from '@/lib/navigation-is-mobile';
import { mountVueComponent } from '@/lib/mount-vue-component';
import { registerAutosaveCommentListeners } from '@/lib/autosaver-comment';
import stickybits from 'stickybits';
import tectoastr from '@/lib/tectoastr';
import VideoThumbnails from '@/lib/video-thumbnails.js';

export default function () {
	if (!isMobile()) {
		stickybits('.header-controls', { useStickyClasses: true });
	}

	const cards = new Cards();
	cards.setup('ul.cards:not(.vertical-gallery)', 'li', 'fitRows');

	const audio = new Audio();
	audio.setup('jp-jplayer');

	const videoThumbnails = new VideoThumbnails();
	videoThumbnails.setup('preview-container.video');

	/**
	 * Decide (pass/unsure/fail) buttons
	 */
	const buttons = $('.decide-button, .undecide-button');
	const undecideButton = $('.undecide-button');

	$(buttons).on('click', function () {
		const button = $(this);
		if (!button.data('url')) {
			return;
		}

		const decision = button.data('decision');

		// Check if already deciding
		if (button.hasClass('deciding')) {
			return;
		}

		button.addClass('deciding');

		// Send new decision to server
		$.ajax({
			type: 'POST',
			url: button.data('url'),
			data: { decision: decision },
			dataType: 'json',
		})
			.done(function () {
				// Update button
				buttons.removeClass('deciding pass fail unsure');
				button.addClass(decision);

				// Show/hide Undecide Button
				undecideButton.toggleClass('hidden', !decision);
			})
			.fail(function (response) {
				// Throw error
				tectoastr.response(response.responseJSON, response.responseJSON.message || button.data('failed'));

				// Toggle button back
				button.removeClass('deciding');
			});
	});

	registerAutosaveCommentListeners([...buttons, ...undecideButton]);

	import('@/lib/components/Video/VideoPlayer').then((videoPlayer) => {
		mountVueComponent('video-player', videoPlayer);
	});

	import('@/lib/components/Video/VideoModal.vue').then((videoModal) => {
		mountVueComponent('video-modal', videoModal);
	});

	import('@/lib/components/Comments/Comments.vue').then((comments) => {
		mountVueComponent('comments', comments);
	});

	import('@/lib/components/QuickManager/QuickManager.vue').then((quickManager) => {
		mountVueComponent('quick-manager', quickManager);
	});

	import('@/lib/components/Shared/PdfViewer/PdfViewer.vue').then((pdfViewer) => {
		mountVueComponent('pdf-viewer', pdfViewer);
	});

	import('@/lib/components/Fields/AIAgentField.vue').then((aiAgentField) => {
		mountVueComponent('ai-agent-field', aiAgentField);
	});
}
